import { IconAlertsPhone } from '@doltech/icons/IconAlertsPhone';
import { IconContentPin } from '@doltech/icons/IconContentPin';
import { IconInterfaceEssentialFacebookMessanger } from '@doltech/icons/IconInterfaceEssentialFacebookMessanger';
import * as React from 'react';

import { Typography } from '../../../../DesignSystemV2/Typography';
import { Link } from '../../../../Link';
import { contactLinks } from '../../model/menus/static-menus';
import { SocialButtonGroup } from '../../SocialButton/SocialButtonGroup/SocialButtonGroup';
import styled from 'styled-components';

const Main = styled.div`
  .contactInfo {
    margin-bottom: 32px;
    white-space: normal;
  }
  .contactInfo .contactLink {
    display: flex;
    align-items: center;
    color: inherit;
  }
  .contactInfo .contactLink:not(:last-child) {
    margin-bottom: 32px;
  }
  .contactInfo .contactLink:hover {
    color: #d14242;
  }
`;

const IconMapper = {
  pin: IconContentPin,
  messenger: IconInterfaceEssentialFacebookMessanger,
  phone: IconAlertsPhone,
};

export const ContactInfo = () => {
  return (
    <Main>
      <Typography.Title
        level={4}
        variant="semi-bold/20"
        mb="12px"
        p="12px 12px 12px 0"
        color="black80"
      >
        Thông tin liên hệ
      </Typography.Title>
      <div className={'contactInfo'}>
        {contactLinks.map(({ id, url, text, icon, iconColor }) => {
          const Icon = IconMapper[icon];
          return (
            <Link key={id} href={url} className={'contactLink'} rel="nofollow" target="_blank">
              <Icon fontSize={24} color={iconColor} mr="16px" />
              <Typography.Text variant="regular/16">{text}</Typography.Text>
            </Link>
          );
        })}
      </div>
      <SocialButtonGroup />
    </Main>
  );
};
